"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = exports.CtaWrapper = exports.MarginWrapper = exports.ErrorMsgWrapper = exports.ErrorTextContent = exports.ErrorImage = exports.ErrorContent = exports.ErrorContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.ErrorContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    height: 100vh;\n    overflow: hidden;\n    padding-top: var(--sat);\n    padding-bottom: var(--sab);\n"], ["\n    background: ", ";\n    height: 100vh;\n    overflow: hidden;\n    padding-top: var(--sat);\n    padding-bottom: var(--sab);\n"])), function (props) { return props.theme.colors[props.theme.colorMode].background_Primary; });
exports.ErrorContent = styled_components_1.default.div(function (_a) {
    var theme = _a.theme;
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        height: "100%",
        paddingBottom: theme.spacing.xxLarge,
        top: "15%",
        position: "relative",
    };
});
exports.ErrorImage = styled_components_1.default.div(function (_a) {
    var theme = _a.theme;
    var colorMode = theme.colorMode;
    return {
        width: "100vw",
        height: "75vh",
        position: "fixed",
        objectFit: "fill",
        objectPosition: "center center",
        margin: "0 auto",
        background: theme.colors[colorMode].background_Primary,
    };
});
exports.ErrorTextContent = styled_components_1.default.div(function (_a) {
    var theme = _a.theme;
    return {
        marginTop: theme.spacing.xLarge,
        padding: "0 60px",
        zIndex: "1",
    };
});
exports.ErrorMsgWrapper = styled_components_1.default.div(function (_a) {
    var theme = _a.theme;
    return {
        marginTop: theme.spacing.xxSmall,
    };
});
exports.MarginWrapper = styled_components_1.default.div(function (_a) {
    var theme = _a.theme;
    return {
        marginTop: theme.spacing.xLarge,
    };
});
exports.CtaWrapper = styled_components_1.default.div(function (_a) {
    var theme = _a.theme;
    return {
        marginTop: theme.spacing.large,
    };
});
exports.BackButton = styled_components_1.default.div(function (_a) {
    var theme = _a.theme;
    return {
        position: "absolute",
        left: theme.spacing.medium,
    };
});
var templateObject_1;
